import { LOGIN_ERROR, LOGIN_SUCCESS } from '@/actions/login/types';

const initialState = {
  token: null,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        user_id: action.payload.user_id,
        picture: action.payload.picture,
        name: action.payload.name,
        error: false,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        token: null,
        error: true,
      };
    default:
      return state;
  }
}
